import { ProductSource } from "@redotech/redo-prisma-client/enums";
import { assertNever } from "@redotech/util/type";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { productCategoryIdFormat } from "../ids";

export const ProductCategorySourceSchema = createEnum(ProductSource);
export type ProductCategorySource = z.infer<typeof ProductCategorySourceSchema>;

export const RawProductCategorySourceSchema = createEnum([
  "shopify",
  "bigcommerce",
  "commentsold",
  "commerce-cloud",
  "cin7-omni",
  "cin7-core",
  "amazon",
  "ebay",
]);
export type RawProductCategorySource = z.infer<
  typeof RawProductCategorySourceSchema
>;

function transformProductCategorySource(
  source: ProductCategorySource | RawProductCategorySource,
): ProductCategorySource {
  switch (source) {
    case "shopify":
      return ProductSource.Shopify;
    case "bigcommerce":
      return ProductSource.BigCommerce;
    case "commentsold":
      return ProductSource.CommentSold;
    case "commerce-cloud":
      return ProductSource.CommerceCloud;
    case "cin7-omni":
      return ProductSource.Cin7Omni;
    case "cin7-core":
      return ProductSource.Cin7Core;
    case "amazon":
      return ProductSource.Amazon;
    case "ebay":
      return ProductSource.ebay;
    case "Shopify":
      return source;
    case "BigCommerce":
      return source;
    case "CommentSold":
      return source;
    case "CommerceCloud":
      return source;
    case "Cin7Omni":
      return source;
    case "Cin7Core":
      return source;
    case "Amazon":
      return source;
    default:
      assertNever(source);
  }
}

export const ProductCategorySchema = z.object({
  id: productCategoryIdFormat.schema,
  name: z.string(),
  source: z
    .union([ProductCategorySourceSchema, RawProductCategorySourceSchema])
    .transform(transformProductCategorySource),
  sourceId: z.string(),
  parentId: productCategoryIdFormat.schema.nullable(),
});
export type ProductCategory = z.infer<typeof ProductCategorySchema>;
